import { render, staticRenderFns } from "./IllustrationMoneyBagzSparkles.svg?vue&type=template&id=6eceed33&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports